import React, { useState } from 'react';
import { func, object, string } from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'ramda';
import moment from 'moment';
import { Form } from 'antd';

import { closeCurrentModal } from '../modal-reducer';
import { handleMultipleRequestTasksCreate } from '../../redux/thunk/tasks';

import {
  Title,
  SubTitle,
  TaskList,
  FormAddTask,
  ModalButton,
  FormFieldAdd,
  FormFieldLabel,
  FormFieldWrapper,
  RangeButtonWrapper,
  FormContentWrapper,
  RangeInputContainer,
  ModalButtonGradient,
} from '../change-status/styled-components';

import { theme } from '../../styles';
import Task from '../../components/tasks-list/task';
import { getItemById, getItemByPath } from '../../utils';
import { AddTaskContent, EditTaskContent } from '../change-status/tasks';


export const noUndoneTasksModalComponent = ({
  modal, form: {
    getFieldDecorator, getFieldsValue, validateFields, setFieldsValue, getFieldsError,
  },
  users,
  requests,
  closeModal,
  createMultipleTasksAction,
}) => {
  const {
    requestId,
  } = modal.payload;

  const request = getItemById(requestId, requests);
  const requestAssignees = request.assignees
    ? request.assignees.map(assignee => getItemByPath(['items', assignee], users))
    : null;
  const [addTask, setAddTask] = useState(false);
  const [editTask, setEditTask] = useState(false);
  const [tasksList, setTasksList] = useState([]);
  const [taskId, setTaskId] = useState(null);


  const addTaskHandler = (e) => {
    e.preventDefault();
    setAddTask(true);
  };

  const handleTaskUpdate = (id) => {
    setTaskId(id);
    setEditTask(true);
  };

  const createOrUpdateTaskHelper = () => {
    const task = getFieldsValue(['description', 'dueDate', 'dueTime', 'title', 'userId', 'taskPriority']);
    task.dueTime = task.dueTime ? moment(task.dueTime).format() : '';
    task.dueDate = moment(task.dueDate).format();
    task.assignedTo = task.userId ? users.items[task.userId] : {};
    return task;
  };

  const createTask = (e) => {
    e.preventDefault();
    validateFields(['dueDate', 'title']);
    const { dueDate, title } = getFieldsError(['dueDate', 'title']);
    const task = createOrUpdateTaskHelper();
    if (!dueDate && !title) {
      setTasksList([...tasksList, task]);
      setAddTask(false);
    }
    return null;
  };

  const cancelCreateAndEditTask = (e) => {
    e.preventDefault();
    setAddTask(false);
    setEditTask(false);
  };

  const updateTask = (e) => {
    e.preventDefault();
    validateFields(['dueDate', 'title']);
    const { dueDate, title } = getFieldsError(['dueDate', 'title']);
    const task = createOrUpdateTaskHelper();
    if (!dueDate && !title) {
      tasksList.splice(taskId, 1, task);
      setTasksList([...tasksList]);
      setEditTask(false);
    }
    return null;
  };

  const handleTaskDelete = (id) => {
    const newTaskList = [...tasksList];
    newTaskList.splice(id, 1);
    setTasksList([...newTaskList]);
  };

  const submitFormHandler = (e) => {
    e.preventDefault();

    const tasksToSubmit = tasksList.map((task) => {
      const { userId, ...newObj } = task;
      newObj.assignedTo = userId;
      newObj.requestId = requestId;
      return newObj;
    });

    closeModal();
    return createMultipleTasksAction(requestId, tasksToSubmit);
  };

  return (
    <RangeInputContainer>
      <Form onSubmit={submitFormHandler}>
        <FormContentWrapper>
          <Title>Next Action</Title>
          <SubTitle>
            <p>There are no Undone Tasks for this Request.</p>
            <p>Do you want to add a new one?</p>
          </SubTitle>

          <FormFieldWrapper>
            <FormAddTask
              changePosition={tasksList.length}
            >
              <FormFieldLabel>Tasks:</FormFieldLabel>
              <FormFieldAdd
                onClick={addTaskHandler}
                hideBtn={addTask || editTask}
              >Add task
              </FormFieldAdd>
            </FormAddTask>
            {editTask &&
              <EditTaskContent {...{
                users,
                taskId,
                editTask,
                tasksList,
                updateTask,
                setFieldsValue,
                getFieldDecorator,
                cancelCreateAndEditTask,
              }}
              />
            }
            {addTask &&
              <AddTaskContent
                {...{
                  users,
                  addTask,
                  createTask,
                  setFieldsValue,
                  requestAssignees,
                  getFieldDecorator,
                  cancelCreateAndEditTask,
                }}
              />
            }
            {!addTask && !editTask &&
              <React.Fragment>
                <TaskList display={tasksList.length}>
                  {tasksList.map((task, index) => (
                    <Task
                      {...task}
                      number={index + 1}
                      key={task._id}
                      _id={index}
                      handleTaskUpdate={handleTaskUpdate}
                      handleTaskDelete={handleTaskDelete}
                      hideActions
                    />
                  ))}
                </TaskList>
              </React.Fragment>
            }
          </FormFieldWrapper>
        </FormContentWrapper>

        <RangeButtonWrapper>
          <ModalButton
            backgroundColor={theme.colors.lightGreySilver}
            onClick={(e) => {
              e.preventDefault();
              closeModal();
            }}
          > Close
          </ModalButton>
          <ModalButtonGradient
            disabled={addTask || editTask || isEmpty(tasksList)}
            type="submit"
            onClick={submitFormHandler}
          > Submit
          </ModalButtonGradient>
        </RangeButtonWrapper>
      </Form>
    </RangeInputContainer>
  );
};

noUndoneTasksModalComponent.propTypes = {
  modal: object.isRequired,
  form: object.isRequired,
  users: object.isRequired,
  requestId: string.isRequired,
  closeModal: func.isRequired,
  createMultipleTasksAction: func.isRequired,
  requestValue: string.isRequired,
  requests: object.isRequired,
};

const mapDispatchToProps = dispatch => ({
  createMultipleTasksAction: (requestId, data) =>
    dispatch(handleMultipleRequestTasksCreate(requestId, data)),
  closeModal: () => dispatch(closeCurrentModal()),
});

const mapStateToProps = ({ modal, requests, users }) => ({
  modal,
  requests,
  users,
});

const component = connect(
  mapStateToProps,
  mapDispatchToProps,
)(noUndoneTasksModalComponent);

export const NextActionModal = Form.create({ name: 'modal_form' })(component);



// WEBPACK FOOTER //
// ./src/modals/next-action-modal/index.js